
export default {
  id: 142436378472,
  reviewer: {
    dashboard: {
      activeItem: "-6px",
      body: {
        main: [
          {
            id: 1,
            url: "/ui/reviewer/dashboard",
            ariaLabel: "dashboard",
            iconProps: { iconId: "reviewCaseFull", addClass: "c1" },
            active: true,
          },
        ],
        subMenu: [],
      },
      footer: [
        {
          id: 1,
          elID: "logoutBtn",
          button: "logout",
          ariaLabel: "stage",
          iconProps: { iconId: "logoutFull", addClass: "c12" },
        },
      ],
    },
    stage: {
      activeItem: "46px",
      body: {
        main: [
          {
            id: 1,
            url: "/ui/reviewer/dashboard",
            ariaLabel: "dashboard",
            iconProps: { iconId: "reviewCaseFull", addClass: "c12" },
          },
          {
            id: 2,
            url: "/ui/reviewer/stage",
            urlIdKey: "stage",
            ariaLabel: "stage",
            iconProps: { iconId: "categoriesFull", addClass: "c1" },
            active: true,
          },
        ],
        subMenu: [],
      },
      footer: [
        {
          id: 1,
          elID: "logoutBtn",
          button: "logout",
          ariaLabel: "stage",
          iconProps: { iconId: "logoutFull", addClass: "c12" },
        },
      ],
    },
    collection: {
      activeItem: "97px",
      body: {
        main: [
          {
            id: 1,
            url: "/ui/reviewer/dashboard",
            ariaLabel: "dashboard",
            iconProps: { iconId: "reviewCaseFull", addClass: "c12" },
          },
          {
            id: 2,
            url: "/ui/reviewer/stage",
            urlIdKey: "stage",
            ariaLabel: "stage",
            iconProps: { iconId: "categoriesFull", addClass: "c12" },
          },
          {
            id: 3,
            url: "/ui/reviewer/collection",
            ariaLabel: "collection",
            urlIdKey: "collection",
            iconProps: { iconId: "listFull", addClass: "c1" },
            active: true,
          },
        ],
        subMenu: [],
      },
      footer: [
        {
          id: 1,
          elID: "logoutBtn",
          button: "logout",
          ariaLabel: "stage",
          iconProps: { iconId: "logoutFull", addClass: "c12" },
        },
      ],
    },
    case: {
      body: {
        main: [
          {
            id: 1,
            url: "/ui/reviewer/dashboard",
            ariaLabel: "dashboard",
            iconProps: { iconId: "reviewCaseFull", addClass: "c12" },
          },
          {
            id: 2,
            url: "/ui/reviewer/stage",
            ariaLabel: "stage",
            urlIdKey: "stage",
            iconProps: { iconId: "categoriesFull", addClass: "c12" },
          },
          {
            id: 3,
            url: "/ui/reviewer/collection",
            ariaLabel: "collection",
            urlIdKey: "collection",
            iconProps: { iconId: "listFull", addClass: "c12" },
          },
        ],
        subMenu: [],
      },
      footer: [
        {
          id: 1,
          elID: "logoutBtn",
          button: "logout",
          ariaLabel: "stage",
          iconProps: { iconId: "logoutFull", addClass: "c12" },
        },
      ],
    },
  },
  review_admin: {
    dashboard: {
      activeItem: "-6px",
      body: {
        main: [
          {
            id: 1,
            url: "/ui/review_admin/dashboard",
            ariaLabel: "dashboard",
            iconProps: { iconId: "reviewCaseFull", addClass: "c1" },
            active: true,
          },
        ],
        subMenu: [],
      },
      footer: [
        {
          id: 1,
          elID: "logoutBtn",
          button: "logout",
          ariaLabel: "stage",
          iconProps: { iconId: "logoutFull", addClass: "c12" },
        },
      ],
    },
    stage: {
      activeItem: "46px",
      body: {
        main: [
          {
            id: 1,
            url: "/ui/review_admin/dashboard",
            ariaLabel: "dashboard",
            iconProps: { iconId: "reviewCaseFull", addClass: "c12" },
          },
          {
            id: 2,
            url: "/ui/review_admin/stage",
            urlIdKey: "stage",
            ariaLabel: "stage",
            iconProps: { iconId: "categoriesFull", addClass: "c1" },
            active: true,
          },
        ],
        subMenu: [],
      },
      footer: [
        {
          id: 1,
          elID: "logoutBtn",
          button: "logout",
          ariaLabel: "stage",
          iconProps: { iconId: "logoutFull", addClass: "c12" },
        },
      ],
    },
    collection: {
      activeItem: "97px",
      body: {
        main: [
          {
            id: 1,
            url: "/ui/review_admin/dashboard",
            ariaLabel: "dashboard",
            iconProps: { iconId: "reviewCaseFull", addClass: "c12" },
          },
          {
            id: 2,
            url: "/ui/review_admin/stage",
            urlIdKey: "stage",
            ariaLabel: "stage",
            iconProps: { iconId: "categoriesFull", addClass: "c12" },
          },
          {
            id: 3,
            url: "/ui/review_admin/collection",
            ariaLabel: "collection",
            urlIdKey: "collection",
            iconProps: { iconId: "listFull", addClass: "c1" },
            active: true,
          },
        ],
        subMenu: [],
      },
      footer: [
        {
          id: 1,
          elID: "logoutBtn",
          button: "logout",
          ariaLabel: "stage",
          iconProps: { iconId: "logoutFull", addClass: "c12" },
        },
      ],
    },
    case: {
      body: {
        main: [
          {
            id: 1,
            url: "/ui/review_admin/dashboard",
            ariaLabel: "dashboard",
            iconProps: { iconId: "reviewCaseFull", addClass: "c12" },
          },
          {
            id: 2,
            url: "/ui/review_admin/stage",
            ariaLabel: "stage",
            urlIdKey: "stage",
            iconProps: { iconId: "categoriesFull", addClass: "c12" },
          },
          {
            id: 3,
            url: "/ui/review_admin/collection",
            ariaLabel: "collection",
            urlIdKey: "collection",
            iconProps: { iconId: "listFull", addClass: "c12" },
          },
        ],
        subMenu: [],
      },
      footer: [
        {
          id: 1,
          elID: "logoutBtn",
          button: "logout",
          ariaLabel: "stage",
          iconProps: { iconId: "logoutFull", addClass: "c12" },
        },
      ],
    },
    reviewer: {
      body: {
        main: [
          {
            id: 1,
            url: "/ui/review_admin/dashboard",
            ariaLabel: "dashboard",
            iconProps: { iconId: "reviewCaseFull", addClass: "c12" },
          },
          {
            id: 2,
            url: "/ui/review_admin/stage",
            ariaLabel: "stage",
            urlIdKey: "stage",
            iconProps: { iconId: "categoriesFull", addClass: "c12" },
          },
          {
            id: 3,
            url: "/ui/review_admin/collection",
            ariaLabel: "collection",
            urlIdKey: "collection",
            iconProps: { iconId: "listFull", addClass: "c12" },
          },
        ],
        subMenu: [],
      },
      footer: [
        {
          id: 1,
          elID: "logoutBtn",
          button: "logout",
          ariaLabel: "stage",
          iconProps: { iconId: "logoutFull", addClass: "c12" },
        },
      ],
    },
  },
};
